import styled from 'styled-components';

export const Project = styled.div`
  margin: 10px 10px;
  position: relative;

  img {
    max-width: 100%;
    width: 100%;
    display: block;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.3s ease;
  background-color: #199ec6;

  :hover {
    opacity: 0.5;
  }
`;

export const ProjectDescription = styled.div`
  position: absolute;
  top: 40px;
  left: 35px;

  h1 {
    font-weight: 800;
    font-size: 35px;
    line-height: 40px;
    text-transform: uppercase;

    color: #ffffff;
  }

  h2 {
    font-weight: 800;
    font-size: 55px;
    line-height: 60px;
    text-transform: uppercase;

    color: #ffffff;
  }

  @media only screen and (max-width: 1000px) {
    top: 20px;
    left: 15px;

    h1 {
      font-size: 8vw;
      line-height: 10vw;
    }

    h2 {
      font-size: 10vw;
      line-height: 10vw;
    }
  }
`;
